var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_2084_7594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.1131 8.01189L19.9881 3.88689C19.9239 3.82317 19.8477 3.77276 19.7639 3.73854C19.6802 3.70433 19.5905 3.68699 19.5 3.68751H18.125V9.18751C18.125 9.55218 17.9801 9.90192 17.7223 10.1598C17.4644 10.4176 17.1147 10.5625 16.75 10.5625H11.25C10.8853 10.5625 10.5356 10.4176 10.2777 10.1598C10.0199 9.90192 9.875 9.55218 9.875 9.18751V3.68751H5.75C5.20299 3.68751 4.67839 3.90481 4.29159 4.2916C3.9048 4.6784 3.6875 5.203 3.6875 5.75001V22.25C3.6875 22.797 3.9048 23.3216 4.29159 23.7084C4.67839 24.0952 5.20299 24.3125 5.75 24.3125H7.125V18.125C7.125 17.578 7.3423 17.0534 7.72909 16.6666C8.11589 16.2798 8.64049 16.0625 9.1875 16.0625H18.8125C19.3595 16.0625 19.8841 16.2798 20.2709 16.6666C20.6577 17.0534 20.875 17.578 20.875 18.125V24.3125H22.25C22.797 24.3125 23.3216 24.0952 23.7084 23.7084C24.0952 23.3216 24.3125 22.797 24.3125 22.25V8.50001C24.313 8.40953 24.2957 8.31984 24.2615 8.23608C24.2273 8.15231 24.1768 8.07613 24.1131 8.01189Z",
    fill: "#FD9468"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.25 3.6875H16.75V9.1875H11.25V3.6875Z",
    fill: "#FD9468"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M18.8125 17.4375H9.1875C9.00516 17.4375 8.8303 17.5099 8.70136 17.6389C8.57243 17.7678 8.5 17.9427 8.5 18.125V24.3125H19.5V18.125C19.5 17.9427 19.4276 17.7678 19.2986 17.6389C19.1697 17.5099 18.9948 17.4375 18.8125 17.4375Z",
    fill: "#FD9468"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2084_7594)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 14C17.6915 14 15 16.6915 15 20C15 23.3085 17.6915 26 21 26C24.3085 26 27 23.3085 27 20C27 16.6915 24.3085 14 21 14Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2095 21.5031C23.405 21.6987 23.405 22.0146 23.2095 22.2102C23.112 22.3077 22.984 22.3567 22.8559 22.3567C22.728 22.3567 22.6 22.3077 22.5025 22.2102L21 20.7076L19.4975 22.2102C19.4 22.3077 19.272 22.3567 19.144 22.3567C19.016 22.3567 18.888 22.3077 18.7905 22.2102C18.595 22.0146 18.595 21.6987 18.7905 21.5031L20.293 20.0007L18.7905 18.4982C18.595 18.3026 18.595 17.9867 18.7905 17.7911C18.986 17.5957 19.302 17.5957 19.4975 17.7911L21 19.2937L22.5025 17.7911C22.698 17.5957 23.014 17.5957 23.2095 17.7911C23.405 17.9867 23.405 18.3026 23.2095 18.4982L21.707 20.0007L23.2095 21.5031Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2084_7594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(3 3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2084_7594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(15 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveError);
export default __webpack_public_path__ + "static/media/SaveError.ac08832e59db0f082ee70debd84d2bfb.svg";
export { ForwardRef as ReactComponent };